import chalk, { ColorSupport } from 'chalk';
import * as React from 'react';
import { Text, useStdout } from 'ink';
import util from 'util';

const supportsColor = chalk.stderr.supportsColor as ColorSupport;

export default function SyntaxHighlight({
  object,
  colors = supportsColor?.hasBasic,
}: {
  object: object;
  colors?: boolean;
}) {
  const { stdout } = useStdout();

  const highlightedCode = React.useMemo(() => {
    return stdout?.isTTY
      ? util.inspect(object, { colors, depth: 6 })
      : JSON.stringify(object, null, 2);
  }, [colors, object, stdout?.isTTY]);

  return <Text wrap="end">{highlightedCode}</Text>;
}
